export const GET_DASHBOARD_ALERTS_REQUEST = "GET_DASHBOARD_ALERTS_REQUEST";
export const GET_DASHBOARD_ALERTS_SUCCESS = "GET_DASHBOARD_ALERTS_SUCCESS";
export const GET_DASHBOARD_ALERTS_ERROR = "GET_DASHBOARD_ALERTS_ERROR";

export const GET_DASHBOARD_DATA_REQUEST = "GET_DASHBOARD_DATA_REQUEST";
export const GET_DASHBOARD_DATA_SUCCESS = "GET_DASHBOARD_DATA_SUCCESS";
export const GET_DASHBOARD_DATA_ERROR = "GET_DASHBOARD_DATA_ERROR";
